// IMPORT ROUTES 
const { routes } = require(`/src/ts/config/routes.ts`)
require(`/src/sass/global.scss`)

let route: any = routes.find((item: any) => {
	const responseItem: boolean = Array.isArray(item.path) ?
		item.path.some((itemPath: string) => checkRoutePath(itemPath)) :
		checkRoutePath(item.path)

	return responseItem
})

// Check route with location pathname
function checkRoutePath(itemPath: any): boolean {
	return window.location.pathname === itemPath
}

require(`/src/ts/services/general.ts`).page()
// require(`datalayers.ts`)
// console.log( route.hasOwnProperty('page') ? 'has page' : 'has not page' )
if (route) {
	route.hasOwnProperty('page') ? require(`/src/ts/pages/${route.page}.tsx`).page() : require(`/src/ts/pages/${route.component}.tsx`).component()
	route.hasOwnProperty('page') ?? require(`/src/sass/pages/${route.page}.scss`)
} else {
	routeDontFound()
}

/**
 * dinamicRoutes
 * 
 * This function generate the dinamic routes when yu send in the route :
 * 
 * @returns 
 */
function dinamicRoutes() {
	let otherRoutes: any = routes.filter((item: any) => item.path.includes(':'))
	let getRouteCurrent: any = location.pathname.split('/')
	let request: object = {}
	
	otherRoutes.map( (route: any) => request = getRouteCurrent[1] == (route.path.split('/'))[1] ? { 'status': true, 'route': route} : { 'status': false })
	return request
}

function dinamicLang() {
	let otherRoutes = routes.filter((item: any) => {
		return typeof item.path == 'string' ? item.path.includes(':') : item.path.some((pathList: any) => pathList.includes(':'))
	})

	let getRouteCurrent: any = location.pathname.split('/')
	let request: any = {}

	for (const route of otherRoutes) {
		let updatedCurrentRouted = [...getRouteCurrent]

		request = typeof route.path == 'string' ? checkStringPath(route, updatedCurrentRouted) : checkArrayPath(route, updatedCurrentRouted)
		if (request.status) return request
	}

}

function checkArrayPath(route: any, updatedCurrentRouted: Array<string>) {
	let dinamicPaths = route.path.filter((routePath: string) => routePath.includes(':'))

	for (const subRoute of dinamicPaths) {
		// Spliting all routes, find dinamyc lang and path
		let splitRoute = subRoute.split('/')
		let indexLang = splitRoute.findIndex((lang: string) => lang == ':lang')
		let indexPath = splitRoute.findIndex((path: string) => path == ':path')

		// Replace values
		if (indexLang > 0) updatedCurrentRouted[indexLang] = ':lang'
		if (indexPath > 0) updatedCurrentRouted[indexPath] = ':path'

		// Check if current path is same with some routes
		if (updatedCurrentRouted.join('/') == splitRoute.join('/')) return { 'status': true, 'route': route }
	}
	return { 'status': false }
}

function checkStringPath(route: any, updatedCurrentRouted: Array<string>): any {
	// Spliting all routes, find dinamyc lang and path
	let splitRoute = route.path.split('/')
	let indexLang = splitRoute.findIndex((lang: string) => lang == ':lang')
	let indexPath = splitRoute.findIndex((path: string) => path == ':path')

	// Replace values
	if (indexLang > 0) updatedCurrentRouted[indexLang] = ':lang'
	if (indexPath > 0) updatedCurrentRouted[indexPath] = ':path'

	// Check if current path is same with some routes
	return updatedCurrentRouted.join('/') == splitRoute.join('/') ? { 'status': true, 'route': route } : { 'status': false }
}

/**
 * routeDontFound
 * 
 * This function work when route wasn't found
 * 
 * @returns 
 */
function routeDontFound() {
	const dinamic: any = dinamicLang();

	dinamic.status && require(`/src/ts/pages/${dinamic.route.page}.tsx`).page()
}